import React from 'react';
import pageBanner from './../../assets/images/SAMSAHOME-2.png';
import smpageBanner from './../../assets/images/SAMSAHOME.jpg';

function SamsaMandate({ className, isAboutPage }) {
  
  return (
    <section className={`SamsaMandate position-relative px-4 bigarrow ${className}`} id='SamsaMandate'>
      <div className="container max-1330">
        <div className="row g-3 g-sm-4 g-md-5">
          <div className='col-lg-auto'>
            <div className='samsa-img position-relative'>
              <picture>
                <source media="(max-width:757px)" srcSet={smpageBanner} />
                <img src={pageBanner} alt="SAMSA Banner" className='img-fluid' />
              </picture>
            </div>
          </div>

          <div className='col-lg'>
            <h1 className="section-title">About SAMSA</h1>

            {isAboutPage ? (
              <p className="mb-3">
                T​​he South African Maritime Safety Authority (SAMSA) was established on the 1st April 1998 under the SAMSA Act 5 of 1998.
                {/* <br /><br /> The objectives of the Authority are-<br /> */}
                <br />To ensure safety of life and property at sea;<br />
                <br />To prevent and combat pollution from ships in the marine environment; and<br />
                <br />To promote the Republic's maritime interests.<br />
                <br />SAMSA has also been charged with the responsibility of executing the following:<br />
                <br />Administration of the Merchant shipping (National Small Vessel Safety) Regulation, 2007, as amended (the Regulations). <br />
                <br />The Regulations extends SAMSA's Core mandate to include inland waterways (only waterways accessible to the public) within the Republic. That is to ensure boating safety on our waters.<br />
                <br />and executing the Long-Range Identification and Tracking (LRIT) of vessels along the South African coastline. <br />
                <br /><br />
                <br />The Long-Range vessels monitoring system assist in securing South Africa's coastal waters in the midst of the rising lawlessness at sea, with particular reference to the worrying scourge of pirate attacks along the east coast of Africa.​</p>
            ) : (
              <p className="mb-3">
                The South African Maritime Safety Authority (SAMSA) was established on 1 April 1998 under the SAMSA Act 5 of 1998.SAMSA is responsible for ensuring safe and efficient operations in South African waters for the maritime industry, community, and the public. It partners with international organizations like the International Maritime Organization (IMO) and the Association of African Maritime Administrations (AAMA) among others; to improve maritime safety and environmental protection..
              </p>
            )}

            {!isAboutPage && (
              <a href='/About' className='about-btn btn-green-38B652 d-inline-block text-decoration-none'>
                Read More
              </a>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

export default SamsaMandate;
